import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./lib/auth";
import { CartProvider } from "./lib/cart";
import { ContentProvider } from "./lib/content";
import { CurrencyProvider } from "./lib/currency";
import { ProtectedRoute } from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Orders from "./pages/Orders";

import AdminShell from "./pages/admin/AdminShell";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminMarketplace from "./pages/admin/AdminMarketplace";
import AdminManualProducts from "./pages/admin/AdminManualProducts";
import AdminContent from "./pages/admin/AdminContent";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <ContentProvider>
            <CurrencyProvider>
              <BrowserRouter>
                <Toaster position="top-right" richColors />
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />

                  <Route path="/catalog" element={<ProtectedRoute><Catalog /></ProtectedRoute>} />
                  <Route path="/product/:id" element={<ProtectedRoute><ProductDetail /></ProtectedRoute>} />
                  <Route path="/cart" element={<ProtectedRoute><Cart /></ProtectedRoute>} />
                  <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
                  <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />

                  <Route path="/admin" element={<ProtectedRoute adminOnly><AdminShell /></ProtectedRoute>}>
                    <Route index element={<AdminDashboard />} />
                    <Route path="products" element={<AdminProducts />} />
                    <Route path="manual-products" element={<AdminManualProducts />} />
                    <Route path="customers" element={<AdminCustomers />} />
                    <Route path="orders" element={<AdminOrders />} />
                    <Route path="marketplace" element={<AdminMarketplace />} />
                    <Route path="content" element={<AdminContent />} />
                  </Route>

                  <Route path="*" element={<Navigate to="/catalog" replace />} />
                </Routes>
              </BrowserRouter>
            </CurrencyProvider>
          </ContentProvider>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
